import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { api } from '~/redux/api/createApi';

export const useRestrictedFilterIds = () => {
  const enableQuickAiFilters = useFlag(FlagType.QuickAiFilters);

  const { data: xrayFieldIds = [] } =
    api.endpoints.getPromptModelFieldIds.useQuery(undefined, {
      skip: !enableQuickAiFilters,
    });

  return [...xrayFieldIds, 'clause'];
};
